import {
    NeuroglancerManagedUserLayer,
    NeuroglancerRenderLayer,
    NeuroglancerUserLayer,
} from '../neuroglancer-type-mappings'

export type NeuroglancerAnnotationRenderLayer = {
    getPropertiesForId: ((id: number) => number) | null
} & NeuroglancerRenderLayer

export enum LayerType {
    Image = 'image',
    Segmentation = 'segmentation',
    Annotation = 'annotation',
    Selection = 'selection',
}

export const isImageLayer = (layer: NeuroglancerManagedUserLayer | undefined | null): boolean => {
    return layer?.layer?.type === LayerType.Image
}

export const isSegmentationLayer = (
    layer: NeuroglancerManagedUserLayer | undefined | null
): boolean => {
    return layer?.layer?.type === LayerType.Segmentation
}

export const isAnnotationLayer = (
    layer: NeuroglancerManagedUserLayer | undefined | null
): boolean => {
    return layer?.layer?.type === LayerType.Annotation
}

export const isSegmentationUserLayer = (
    layer: NeuroglancerUserLayer | undefined | null
): boolean => {
    return layer?.type === LayerType.Segmentation
}

export const isAnnotationUserLayer = (layer: NeuroglancerUserLayer | undefined | null): boolean => {
    return layer?.type === LayerType.Annotation
}
